import React from 'react'
import PropTypes from 'prop-types'
import mainMenuJson from '#data/mainMenu.json'
import ProgressBar from '#components/a/ProgressBar'
import HeaderLink from '#components/m/MeineAusbildung/HeaderLink'

export default function ProgressOverview({testId, titleKey, percentage, children, showProgressbar = true}) {
  return (
    <div className="progressoverview" data-testid={testId}>
      <div className="header-block">
        <HeaderLink titleKey={titleKey} url={getUrl(titleKey)} />
        {showProgressbar && <ProgressBar percentage={percentage} />}
      </div>
      {children}
    </div>
  )
}

function getUrl(string) {
  return mainMenuJson.links.find(link => link.text === string).url
}

ProgressOverview.propTypes = {
  titleKey: PropTypes.string,
  percentage: PropTypes.number,
  children: PropTypes.node,
  showProgressbar: PropTypes.bool,
  testId: PropTypes.string,
}
